import { Icon } from '../Icon'

/**
 * Дельта и список замечаний.
 *
 * Оба примитива живут в общем пакете, а не на экране консоли,
 * потому что дельту одометра видит и водитель в своей истории
 * поездок. Копия в водительском приложении означала бы, что
 * правка формата в одном месте до второго не доедет —
 * ровно то, что ловит страж дублирования.
 *
 * FlagList при этом остаётся общим примитивом, а не «админским»:
 * решение, кому показывать замечания, принимает сервер, который
 * водителю их просто не отдаёт. Компонент, знающий про роли,
 * создавал бы иллюзию, что скрытие в интерфейсе — это защита.
 */

const FLAG_TONE = { critical: 'danger', warning: 'warning', info: 'info' }
const FLAG_ICON = { critical: 'warning', warning: 'warning', info: 'file' }

/**
 * Посчитанная разница.
 *
 * value — итог, hint — из чего он получен. Разделение не
 * косметическое: диспетчеру нужен ответ, но он должен иметь
 * возможность проверить, откуда тот взялся.
 */
export function DeltaStat({ label, value, hint = null, tone = null }) {
  return (
    <div className={`delta${tone ? ` delta--${tone}` : ''}`}>
      <p className="delta__label">{label}</p>
      <p className="delta__value">{value}</p>
      {hint && <p className="delta__hint">{hint}</p>}
    </div>
  )
}

/**
 * Замечания по поездке.
 *
 * Пустой список — это результат, а не отсутствие данных, поэтому
 * он получает явную формулировку. Молчаливая пустота читается как
 * «не посчитали», и диспетчер идёт перепроверять руками то,
 * что уже проверено.
 */
export function FlagList({ flags, cleanText = 'Замечаний нет.', label = 'Замечания' }) {
  if (!flags?.length) {
    return (
      <div className="flags flags--clean">
        <Icon name="check" size={16} />
        <span>{cleanText}</span>
      </div>
    )
  }

  return (
    <ul className="flags" aria-label={label}>
      {flags.map((flag) => (
        <li
          key={flag.code}
          className={`flags__item flags__item--${FLAG_TONE[flag.level] || 'info'}`}
        >
          <Icon name={FLAG_ICON[flag.level] || 'file'} size={16} />
          <div>
            <p className="flags__title">{flag.title}</p>
            {flag.detail && <p className="flags__detail">{flag.detail}</p>}
          </div>
        </li>
      ))}
    </ul>
  )
}
